import { connect } from 'react-redux';
import { isInitialized, getCommentState } from '../../selectors';
var getPropWithSelector = function (state, commentId, selector, defaultValue) {
    if (isInitialized(commentId)(state)) {
        return selector(commentId)(state);
    }
    return defaultValue;
};
var mapStateToProps = function (state, ownProps) { return ({
    comment: getPropWithSelector(state, ownProps.comment.commentId, getCommentState, ownProps.comment),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=CommentContext.container.js.map